import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import {
    getUserHideEmptyCustomProperties
} from '../../../../../../../../store/model/authUser/selectors/getUserHideEmptyCustomProperties';
import {
    authUserSetHideEmptyCustomProperties
} from '../../../../../../../../rest/effects/authUser/authUserSetHideEmptyCustomProperties';

export const onHideEmpty = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const isHide = getUserHideEmptyCustomProperties(getState());
        dispatch(segmentTrackAction(isHide
            ? SegmentCardEvent.CUSTOM_PROPERTIES_SHOW_CLICKED
            : SegmentCardEvent.CUSTOM_PROPERTIES_HIDE_CLICKED
        ));
        dispatch(authUserSetHideEmptyCustomProperties(!isHide));
    };
    return action;
};
